import { Filter } from '~commonInfra/utils/Filter';
import { ServerApiMapper } from '~commonInfra/utils/ServerModelHelper';
import { IOrderClause } from '~src/spacesPlatform/serverApi/types/IOrderClause';

import { WebClientListResourceFetcher } from '../../httpClient/fetchers/resourceFetchers/WebClientListResourceFetcher';
import { FieldValuesQuery } from '../../httpClient/resources/FieldValuesQuery';
import { IListResource } from '../../httpClient/resources/Resource';
import { ResourceQuery } from '../../httpClient/resources/ResourceQuery';
import { GetFieldValuesRequest } from '../../httpClient/serverApi/requests/GetFieldValuesRequest';
import WebHttpClient from '../../httpClient/WebHttpClient';
import { FilterFieldNames, ILeafFilterClause } from '../../spacesPlatform/models/IFilterClause';
import { FlowOutputStepRunListItemInfo } from '../models/FlowOutputStepRunInfo';
import { GetFlowOutputStepRunsRequest } from '../serverApi/requests/GetFlowOutputStepRunsRequest';
import { GetMostRecentFlowOutputStepRunRequest } from '../serverApi/requests/GetMostRecentFlowOutputStepRunRequest';

export class FlowOutputStepRunsResource implements IListResource<FlowOutputStepRunListItemInfo> {

  private listFetcher = new WebClientListResourceFetcher(GetFlowOutputStepRunsRequest, ServerApiMapper.flowOutputStepRuns);
  private fieldValuesFetcher = new WebClientListResourceFetcher(GetFieldValuesRequest, ServerApiMapper.fieldValues);

  public all(): ResourceQuery<FlowOutputStepRunListItemInfo> {
    return new ResourceQuery(this.listFetcher);
  }

  public getForFlow(flowId: string, orderClause: IOrderClause[]): ResourceQuery<FlowOutputStepRunListItemInfo> {
    const filterClause: ILeafFilterClause[] = [Filter.stringFieldEq(FilterFieldNames.flowId, flowId)];
    return this.all().withFiltersAndOrder(filterClause, orderClause);
  }

  public getMostRecentForFlow(flowId: string, completedRunsOnly: boolean): Promise<ReadonlyArray<FlowOutputStepRunListItemInfo>> {
    return WebHttpClient.sendRequest(new GetMostRecentFlowOutputStepRunRequest({ flowId, completedRunsOnly }))
      .then((result) => ServerApiMapper.flowOutputStepRuns(result));
  }

  public valuesForField(field: string): FieldValuesQuery {
    return new FieldValuesQuery(this.fieldValuesFetcher, field, 'flowOutputStepRun');
  }
}

export const FlowOutputStepRuns = new FlowOutputStepRunsResource();
